export function StatusBadge({ status }) {
  const map = {
    DRAFT: { cls: "badge-draft", label: "Draft" },
    BALANCE_PENDING: { cls: "badge-pending", label: "Balance Pending" },
    CLEARED: { cls: "badge-cleared", label: "Cleared" },
    CANCELLED: { cls: "badge-cancelled", label: "Cancelled" },
  };
  const s = map[status] || { cls: "badge-mute", label: status || "—" };
  return <span className={`badge badge-lg ${s.cls}`} data-testid={`status-${status}`}>{s.label}</span>;
}
